import { Controller } from "@hotwired/stimulus"

// Intercepts archive clicks on notifications and shows a modal explaining
// that archiving is org-wide. "Don't show this again" persists a user
// preference so the modal is skipped on subsequent archive clicks.
//
// The archive link itself must NOT carry method: :patch / data-turbo-method,
// otherwise Turbo/UJS submits the request on click before the modal can show.
// This controller fires the PATCH itself (see archiveFromLink).
export default class extends Controller {
  static targets = ["modal", "checkbox"]
  static values = { skip: Boolean, preferencePath: String }

  connect() {
    this.pendingLink = null
  }

  prompt(event) {
    event.preventDefault()
    const link = event.currentTarget

    if (this.skipValue) {
      this.archiveFromLink(link)
      return
    }

    this.pendingLink = link
    if (this.hasCheckboxTarget) this.checkboxTarget.checked = false
    $(this.modalTarget).modal('show')
  }

  confirm() {
    if (this.hasCheckboxTarget && this.checkboxTarget.checked) {
      this.skipValue = true
      this.savePreference()
    }
    $(this.modalTarget).modal('hide')

    const link = this.pendingLink
    this.pendingLink = null
    if (link) this.archiveFromLink(link)
  }

  archiveFromLink(link) {
    const token = document.querySelector('meta[name="csrf-token"]')?.content
    fetch(link.href, {
      method: 'PATCH',
      headers: {
        'X-CSRF-Token': token,
        'Accept': 'text/vnd.turbo-stream.html'
      }
    }).then(resp => resp.text()).then(html => {
      if (window.Turbo && html) window.Turbo.renderStreamMessage(html)
    }).catch(err => console.error('archive-confirm request failed', err))
  }

  savePreference() {
    const path = this.preferencePathValue
    if (!path) return
    const token = document.querySelector('meta[name="csrf-token"]')?.content
    const formData = new FormData()
    formData.append('preference[hide_archive_confirmation]', '1')
    formData.append('_method', 'patch')
    if (token) formData.append('authenticity_token', token)
    fetch(path, { method: 'POST', body: formData })
      .catch(err => console.error('archive-confirm preference save failed', err))
  }
}
